<script setup>
import { computed } from "vue"
const props = defineProps({
   itemsStringArray: {
      type: [String, Array],
      required: true,
   },
})
const array = computed(() => {
   try {
      if (Array.isArray(props.itemsStringArray)) {
         return props.itemsStringArray;
      } else {
         return JSON.parse(props.itemsStringArray) || []
      }
   } catch (error) {
      return []
   }
})
</script>

<template>
   <div class="button_info">
      <button class="button_info--arround" type="button" v-for="(item, index) in array" :key="index">
         {{ item }}
      </button>
   </div>
</template>

<style lang="scss">
.button_info {
   display: flex;
   gap: 12px;
}

.button_info--arround {
   color: var(--data_color_additional_text);
   padding: 8px 14px;
   border-radius: 50px;
   // border: 1px solid #565759;
   border: 1px solid var(--data_color_additional_border);
   white-space: nowrap;
   font-size: calc(1.0rem* var(--app-font-size));
}
</style>
